import React from "react";
import STSStyles from "../../styles/components/StudentTestSelector.module.css";

export default function SpeakingTestInstructions() {
    return (
        <div className={STSStyles.instructionsContainer}>
            <h2 className={STSStyles.instructionsTitle}>Speaking Test Instructions</h2>
            <p className={STSStyles.instructionsWelcome}>
                This test checks your speaking and listening in English.
            </p>

            <ol className={STSStyles.instructionsList}>
                <li><strong>About the test:</strong> Not pass/fail. It shows what you can do.</li>
                <li><strong>How it works:</strong> You will hear a question. Then speak your answer.</li>
                <li><strong>Time:</strong> The test is about <b>30 minutes</b>.</li>
                <li><strong>Rules:</strong> Do not use a translator or help from others. Do not close or refresh the page.</li>
            </ol>
        </div>
    );
}
